import React from 'react'
import { Table, Header, flexRender } from '@tanstack/react-table'
import { ArrowDown2, ArrowUp2 } from 'iconsax-react'
import { useTheme } from '@mui/material'

import HeaderComponent from '../../Header'
import TableHeaderFilterComponent from '../TableHeaderFilterComponent'

type TableHeaderComponentProps<T> = {
  table: Table<T>
  header: Header<T, unknown>
  manualPagination: boolean
  numResults: number
  hideCount: boolean
  allowDragDropSort: boolean
  enableResizing: boolean
  i: number
}

const TableHeaderComponent = <T extends unknown>({
  table,
  header,
  manualPagination,
  numResults,
  hideCount,
  allowDragDropSort,
  enableResizing,
  i
}: TableHeaderComponentProps<T>) => {
  const theme = useTheme()

  const [hovering, setHovering] = React.useState(false)

  const isFirst = i === 0
  const numRows = table.getRowModel().rows.length
  const total = manualPagination ? numResults ?? numRows : numRows
  const count = isFirst && ` (${total} RESULT${total === 1 ? '' : 's'})`
  const sortDir = header.column.getIsSorted()
  const columnDef = header.column.columnDef
  const defHeader = columnDef.header

  return (
    <th
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      colSpan={header.colSpan}
      className='table-head table-t'
      style={{
        minWidth: enableResizing ? header.getSize() : 'unset',
        width: enableResizing ? header.getSize() : 'unset',
        maxWidth: enableResizing ? header.getSize() : 'unset',
        cursor: header.column.getCanSort() ? 'pointer' : 'default'
      }}
    >
      {header.isPlaceholder ? null : (
        <div
          onClick={header.column.getToggleSortingHandler()}
          style={{ display: 'flex', whiteSpace: 'nowrap' }}
        >
          {isFirst && allowDragDropSort && <div style={{ width: '24px' }} />}

          {flexRender(
            typeof defHeader === 'string' ? (
              <HeaderComponent>{defHeader}</HeaderComponent>
            ) : (
              defHeader
            ),
            header.getContext()
          )}

          {!hideCount && count}

          {/* @ts-expect-error Can exist */}
          {columnDef.customFilter && (
            <TableHeaderFilterComponent hovering={hovering}>
              {/* @ts-expect-error Can exist */}
              {columnDef.customFilter}
            </TableHeaderFilterComponent>
          )}

          <span className='sort'>
            {sortDir &&
              (sortDir === 'desc' ? (
                <ArrowDown2 variant='Bold' size={theme.size.sm} />
              ) : (
                <ArrowUp2 variant='Bold' size={theme.size.sm} />
              ))}
          </span>
        </div>
      )}

      {enableResizing && (
        <div
          onMouseDown={header.getResizeHandler()}
          onTouchStart={header.getResizeHandler()}
          className='resizer'
        />
      )}
    </th>
  )
}

export default TableHeaderComponent
